/* 🤖 this file was generated by svg-to-ts */
export const iccIconEdit: {
  name: 'edit';
  data: string;
} = {
  name: 'edit',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.999 21.001h3.75l11.06-11.06-3.75-3.75-11.06 11.06v3.75Zm2-2.92 9.06-9.06.92.92-9.06 9.06h-.92v-.92ZM18.369 3.291a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34Z" fill="currentColor"/></svg>`
};
